const InputHelper = {
  inputDigitOnly(evt) {
    if (evt.which < 48 || evt.which > 57) {
      evt.preventDefault();
    }
  },

  isIOS() {
    const isIOS = navigator.userAgent.match("iPad") || navigator.userAgent.match("iPone") || navigator.userAgent.match("iPod")
    return isIOS
  },

  isAndroid() {
    const isAndroid = navigator.userAgent.match('Android');
    return isAndroid;
  },

  isWindow() {
    const isAndroid = navigator.userAgent.match('Windows');
    return isAndroid;
  },

  detectInstall() {
    let fallbackLink = "http://example.com/my-web-app/" + window.location.search + window.location.hash;
    const isIOS = this.isIOS();
    const isAndroid = this.isAndroid();
    if (isIOS || isAndroid) {
      document.getElementById("loader").src = "custom-protocol://my-app" + window.location.search + window.location.hash;
      fallbackLink = isAndroid ? "https://play.google.com/store/apps/details?id=com.mycompany.myapp" : "itms-apps://itunes.apple.com/app/my-app/idxxxxxxxxx?mt=8";
    }
    window.setTimeout((x) => {
      window.location.replace(fallbackLink), 10
    })
  }
};

export default InputHelper;



// WEBPACK FOOTER //
// ./src/common/helper/InputHelper.js